/**
 * Calculate and update values for tick spacing and nice
 * minimum and maximum data points on the axis.
 */
export function calculateTicks(maxTicks: number, minPoint: number, maxPoint: number): [number, number, number, number] {
    let range = niceNum(maxPoint - minPoint, false);
    let tickSpacing = niceNum(range / (maxTicks - 1), true);
    let niceMin = Math.floor(minPoint / tickSpacing) * tickSpacing;
    let niceMax = Math.ceil(maxPoint / tickSpacing) * tickSpacing;
    let tickCount = (niceMax - niceMin) / tickSpacing + 1;
    return [tickCount, niceMin, niceMax, tickSpacing];
}

/**
 * Returns a "nice" number approximately equal to range Rounds
 * the number if round = true Takes the ceiling if round = false.
 *
 * @param range the data range
 * @param round whether to round the result
 * @return a "nice" number to be used for the data range
 */
function niceNum(range: number, round: boolean): number {
    let exponent: number;
    /** exponent of range */
    let fraction: number;
    /** fractional part of range */
    let niceFraction: number;
    /** nice, rounded fraction */

    exponent = Math.floor(Math.log10(range));
    fraction = range / Math.pow(10, exponent);

    if (round) {
        if (fraction < 1.5)
            niceFraction = 1;
        else if (fraction < 2.5)
            niceFraction = 2;
        else if (fraction < 3.5)
            niceFraction = 3;
        else if (fraction < 4.5)
            niceFraction = 4;
        else if (fraction < 5.5)
            niceFraction = 5;
        else if (fraction < 6.5)
            niceFraction = 6;
        else if (fraction < 7.5)
            niceFraction = 7;
        else if (fraction < 8.5)
            niceFraction = 8;
        else
            niceFraction = 10;
    } else {
        if (fraction <= 1)
            niceFraction = 1;
        else if (fraction <= 2)
            niceFraction = 2;
        else if (fraction <= 3)
            niceFraction = 3;
        else if (fraction <= 4)
            niceFraction = 4;
        else if (fraction <= 5)
            niceFraction = 5;
        else if (fraction <= 6)
            niceFraction = 6;
        else if (fraction <= 7)
            niceFraction = 7;
        else if (fraction <= 8)
            niceFraction = 8;
        else
            niceFraction = 10;
    }

    return niceFraction * Math.pow(10, exponent);
}